import {css} from "@emotion/react";


const styles = {
    drawerItems: css`
        div {
            height: 56px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .active-tab {
            border-left: 8px solid #5834A8;
            border-radius: 8px;
            
            &::after {
                content: " ";
                display: block;
                position: absolute;
                height: 100px;
                left: -73px;
                top: -20px;
                background: radial-gradient(50% 50% at 50% 50%, rgba(71, 121, 246, 0.35) 0%, rgba(0, 2, 140, 0) 100%);
                width: 100%;
                border-radius: 8px;
                border-left-width: 4px;
                padding: 16px 32px;
            }


        }
    `,
}

export default styles